// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"x2_qx","container":"x2_e","heading":"x2_ce","text":"x2_jv","mapMode":"x2_x1","seeAllLink":"x2_x3"};